(function () {
    const $ = require('jquery');

    var scrollToFirstError = function () {
        var $ = require('jquery');
        var $errors = $('form .has-error');

        if ($errors.length == 0) {
            return;
        }

        var width = $(window).width();
        var $error = $errors.first();
        var top = $error.offset().top;

        if (width <= 480) {
            top -= 20;
        } else {
            top -= 200;
        }

        $('html, body').animate({
            scrollTop: top,
        }, 100);
    };

    scrollToFirstError();

    var autoSubmit = function () {
        $('select[data-autosubmit]').on('change', function () {
            $(this).closest('form').submit();
        });
    };

    autoSubmit();
}());
